import { Status } from "src/core/constants/folders";

/**
 * @description Map un code statut vers un statut personnalisé.
 * @param code - Code statut
 * @returns @see {@link Status}
 */
export const mapCodeToCustomStatus = (code?: string): Status | undefined => {
  return code && (Object.values(Status) as string[]).includes(code) ? (code as Status) : undefined;
};
